import { DataGridPremium as MUIDataGrid } from '@mui/x-data-grid-premium';
import { DataGridProps } from '../types/data-grid-props.type';

export const DataGrid: React.FC<DataGridProps> = (props) => {
  const { children, ...dataGridProps } = props;
  return <MUIDataGrid {...dataGridProps}>{children}</MUIDataGrid>;
};
